// extracted by mini-css-extract-plugin
export default {"page":"iC","wrapper":"jC","text":"kC","icons":"lC","icon":"mC","icon_text":"nC","carousel_wrapper":"oC","slide":"pC","image":"qC","arrows":"rC","prev":"sC","modal_root":"tC","x_mark":"uC","modal":"vC","images":"wC","main_image":"xC","name":"yC"};
    if(module.hot) {
      // 1713996747418
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  